import { useField } from 'formik';
import { useRef } from 'react';

import * as graphql from '@treams/treams-network';

import EditSubgoalCard from './EditSubgoalCard';

export default function CreateSubgoalCard(props: {
	type: graphql.GoalChecklistItemType;
	onDismiss: () => void;
}) {
	const [{ value }, , { setValue }] = useField('subgoalIDs');

	const id = useRef(`__${Math.random().toString().replace('.', '')}`).current;

	return (
		<EditSubgoalCard
			subgoalID={id}
			type={props.type}
			isNew
			onDismiss={(success) => {
				props.onDismiss();

				if (!success) {
					return;
				}

				setValue(value.concat([id]));
			}}
		/>
	);
}
